import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AccountResponse } from '../core/models/account-response';
import { environment } from "environments/environment";

@Injectable()
export class QueueService {

  constructor(private readonly _httpClient: HttpClient) { }

  public getQueues({ sortDirection, sortField, pageIndex, pageSize, activeFilters }: { filter: string; sortDirection: 'asc' | 'desc' | ''; sortField: string; pageIndex: number; pageSize: number; activeFilters: unknown[]; }): Observable<AccountResponse> {
    
    const allStringFilterAux = [];
    activeFilters.forEach((item) => {
        if (item['value'] != null && item['value'] != '') {
            const stringFilterAux = [item['id'],item['value']];
            allStringFilterAux.push(stringFilterAux.join('::'));
        }
    });

    const queryFilter = allStringFilterAux.join('--');

    
    const params = new HttpParams()
    .set('page', pageIndex.toString())
    .set('page_size', pageSize.toString())
    .set('sf', sortField?.toString() ? sortField?.toString() : '')
    .set('s', sortField?.toString() ? sortDirection?.toString().toUpperCase() : '')
    .set('f', queryFilter);

    return this._httpClient.get(`${environment.apiUrl}/queues`, {
      params: params
      }).pipe(
          
          map(res =>  <AccountResponse>res)
      );
  }

  getQueueStatus(): Observable < any > {
  return this._httpClient.get(`${environment.apiUrl}/queues/status`);
  }

  getQueue(id: string): Observable < any > {
      return this._httpClient.get(`${environment.apiUrl}/queues/${id}`);
  }

  editQueue(queue, id: string): Observable < any > {
      return this._httpClient.put(`${environment.apiUrl}/queues/${id}`, queue);
  }

  createQueue(queue): Observable < any > {
    return this._httpClient.post(`${environment.apiUrl}/queues`, queue);
  }

  deleteQueue(id: string): Observable < any > {
    return this._httpClient.delete(`${environment.apiUrl}/queues/${id}`);
  }

}
